module.exports = "/_next/static/images/d8270e5420afd6603a7c09363bbfaa72-smiley.svg";